import { render } from "./FileImportComponent.vue?vue&type=template&id=532eb4ed"
import script from "./FileImportComponent.vue?vue&type=script&lang=js"
export * from "./FileImportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__